import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "@/App";

const OUTCOME = {
  booked: ["Записан", "bg-green-100 text-green-700"],
  confirmed: ["Подтвердил", "bg-blue-100 text-blue-700"],
  cancelled: ["Отменил", "bg-red-100 text-red-700"],
  transferred: ["Переведён на мастера", "bg-amber-100 text-amber-700"],
  failed: ["Не состоялся", "bg-red-50 text-red-600"],
  info: ["Консультация", "bg-gray-100 text-gray-600"],
};

export default function PhoneCallsList({ onOpen }) {
  const [calls, setCalls] = useState(null);
  const [error, setError] = useState("");
  const polls = useRef(0);
  const timer = useRef(null);
  const load = () => axios.get(`${API}/phone/calls`).then((r) => {
    setCalls(r.data.calls || []);
    setError("");
    // the backend pulls fresh calls from ElevenLabs in the background (can take ~1-2 min) — keep re-reading quietly
    if (r.data.syncing && polls.current < 12) { polls.current += 1; timer.current = setTimeout(load, 10000); }
  }).catch((e) => {
    setError(e?.response?.data?.detail || (e?.response?.status ? `HTTP ${e.response.status}` : e.message));
    setCalls((prev) => prev || []);
  });
  useEffect(() => { load(); return () => clearTimeout(timer.current); }, []);
  if (calls === null) return <div className="p-4 text-sm text-gray-400">…</div>;
  const total = calls.reduce((a, c) => a + (c.duration_sec || 0), 0);
  return (
    <div className="flex-1 overflow-y-auto" data-testid="phone-calls-list">
      <div className="px-3 py-2 text-xs text-gray-500 border-b border-gray-100">Звонков: {calls.length} · {Math.round(total / 60)} мин</div>
      {error && <div className="px-3 py-2 text-xs text-red-600" data-testid="phone-calls-error">⚠️ История не обновилась: {error}</div>}
      {!calls.length && <div className="p-4 text-sm text-gray-400" data-testid="phone-calls-empty">Звонков пока нет. Подключите телефонного ИИ-администратора в Интеграциях → Voice.</div>}
      {calls.map((c, idx) => {
        const [label, cls] = OUTCOME[c.outcome] || OUTCOME.info;
        const day = new Date(c.created_at).toDateString();
        const prevDay = idx > 0 ? new Date(calls[idx - 1].created_at).toDateString() : null;
        const today = new Date().toDateString();
        const yesterday = new Date(Date.now() - 86400000).toDateString();
        const dayLabel = day === today ? "Сегодня" : day === yesterday ? "Вчера"
          : new Date(c.created_at).toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "long" });
        return (
          <div key={c.id}>
            {day !== prevDay && (
              <div className="px-3 pt-3 pb-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400" data-testid={`phone-calls-day-${day}`}>{dayLabel}</div>
            )}
          <button type="button" onClick={() => onOpen(c.session_id)} data-testid={`phone-call-${c.id}`}
            className="w-full text-left px-3 py-2.5 border-b border-gray-100 hover:bg-gray-50">
            <div className="flex items-center gap-2 text-sm">
              <span>{c.direction === "outbound" ? "📤" : "📞"}</span>
              <span className="font-semibold">{c.caller === "unknown" ? "Неизвестный номер" : c.caller}</span>
              <span className={`text-[11px] px-2 py-0.5 rounded-full ${cls}`}>{label}</span>
              <span className="ml-auto text-xs text-gray-400">{Math.floor((c.duration_sec || 0) / 60)}:{String((c.duration_sec || 0) % 60).padStart(2, "0")}</span>
            </div>
            {c.summary && <div className="text-xs text-gray-600 mt-0.5 line-clamp-2">{c.summary}</div>}
            <div className="text-[10px] text-gray-400 mt-0.5">{new Date(c.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
          </button>
          </div>
        );
      })}
    </div>
  );
}
